import { Row, Col, Container, Button, Figure } from 'react-bootstrap';
import TextType from './TextType';
import './BackgroundCarousel.css';
import './Typed.css';
import './Globe.css';
import PixelTransition from './PixelTransition';
import { Link } from 'react-router-dom';
import ScrollReveal from './ScrollReveal';

import AboutImg from '../Img/Shipping-vs-Delivery-What_s-the-Difference_-01-1024x600.jpg';
// import Director from '../Img/Boss.jpg';
import Earth from "./Globe";
import CountUp from './CountUp';
// import MarqueeDemo from "./Marquee-demo";

//Videos
// import video1 from "../Img/Banner/Video/Big Ship Launch- Float Out of Cruise Ship DISNEY WISH at Meyer Werft Shipyar_4K.mp4";
// import video2 from "../Img/Banner/Video/Changing shipping & global logistics_Full-HD.mp4";
// import video3 from "../Img/Banner/Video/Drone Shot of Cargo Containers Terminal Ships at Dock Port. Stock Videos of _Full-HD.mp4";
import video4 from "../Img/Banner/Video/Logistics Stock Video Of Roadways AirWays Seaways Railways - Cargo_Full-HD.mp4";

import ScrollVelocity from './ScrollVelocity';

// import Animate from "./Animate"

function DarkVariantExample() {


  return (
    <>
      {/* === Hero Section === */}

      <div className="hero-wrapper">
        <div className="main position-relative">

          {/* Background Video */}
          <video
            src={video4}
            className="hero-video"
            autoPlay
            muted
            loop
            playsInline
            preload="metadata"
          />

          {/* Overlay */}
          <div className="hero-overlay" />

          {/* Content */}
          <div className="content position-relative">
            <Row className="justify-content-start align-items-center min-vh-100">
              <Col md={7} lg={6}>
                <div className="m-5 hero-text">

                  {/* Typed Text */}
                  <div className="typed-text mb-3">
                    <TextType
                      text={["Work Together", "Grow Together", "Deliver Excellence"]}
                      typingSpeed={70}
                      pauseDuration={1200}
                      showCursor
                      cursorCharacter="_"
                    />
                  </div>

                  {/* Description */}
                  <p className="responsive-para mb-4">
                    In the pursuit of excellence, there is no finish line.
                    Our leadership team brings deep expertise in logistics and
                    management—driving reliable, scalable, and global solutions.
                  </p>

                  {/* Buttons */}
                  <div className="d-flex gap-3 flex-wrap">
                    <Button as={Link} to="/Contact" variant="light" size="lg" className='ContactButton'>
                      Contact Us
                    </Button>
                    <Button as={Link} to="/Industries" variant="outline-light" size="lg">
                      Explore Industries
                    </Button>
                  </div>
                </div>
              </Col>
            </Row>
          </div>

        </div>
      </div>
      {/* === Second Section === */}


      {/* <Container fluid className="py-4">
        <Row className="g-4 justify-content-center">

          {[video1, video2, video3, video4].map((vid, index) => (
            <Col
              key={index}
              xs={12}
              sm={6}
              lg={3}
            >
              <div className="video-card">
                <video
                  src={vid}
                  className="responsive-video"
                  autoPlay
                  muted
                  loop
                  controls
                  playsInline
                  preload="metadata"
                />
              </div>
            </Col>
          ))}

        </Row>
      </Container> */}
      <Container>
        <Row className="d-flex justify-content-center align-items-center"
        // style={{ minHeight: "100vh" }}
        >
          <Col md={6} className="p-5 justify-text">
            <h1 className="mb-4"> <strong>About Us</strong></h1>
            <p style={{ fontSize: '20px' }}>
              A vision to go across all horizons and be the leading name in the logistics industry through customer focus and service excellence. Today, we spread across 14 countries with over 60 offices to serve our customers. We take pride in our human capital and over 5000 customers being part of our success story.
            </p>
            <p style={{ fontSize: '20px' }}>
              We synergize across the globe with our partners and specialized agencies to develop a strategic network enabled to deliver results and exceeding customer expectations.
            </p>
            <Button as={Link} to="/About" variant="outline-dark" size="lg">Know More</Button>
          </Col>
          <Col md={6}>
            <img src={AboutImg} alt="About" width="100%" />
          </Col>
        </Row>
        <hr style={{ border: '2px', height: '2px', backgroundColor: 'black' }} />
      </Container>

      <Container>

        <h1 className="text-center my-4 text-decoration-underline"><strong>Shipping Services</strong></h1>
        <Row className="g-4 justify-content-center my-4">
          {/* Project Bulk and ODC Cargo Unit */}
          <Col xs={12} sm={6} md={4} className="d-flex justify-content-center">
            <Figure as={Link} to="/Cargo" className="shadow-sm border-0"
              style={{ maxWidth: "360px", borderRadius: "12px", overflow: "hidden" }}>
              <PixelTransition
                firstContent={
                  <img
                    src="https://stevinshipping.com/wp-content/uploads/2022/08/Project-Bulk-and-ODC-Cargo-Unit.jpg"
                    alt="Furniture"
                    style={{ width: "100%", height: "100%", objectFit: "cover", aspectRatio: "4/3" }}
                  />
                }
                secondContent={
                  <div
                    style={{
                      width: "100%",
                      height: "100%",
                      display: "grid",
                      placeItems: "center",
                      backgroundColor: "#111",
                      aspectRatio: "4/3",
                    }}
                  >
                    <p variant="outline-light" className="fw-bold text-center" style={{ fontSize: "clamp(1.25rem, 2vw, 2rem)" }}>
                      Project Bulk and ODC Cargo Unit
                    </p>
                  </div>
                }
                gridSize={12}
                pixelColor="#ffffff"
                animationStepDuration={0.4}
                className="custom-pixel-card"
              />
            </Figure>
          </Col>

          {/* Vessel Chartering */}
          <Col xs={12} sm={6} md={4} className="d-flex justify-content-center">
            <Figure as={Link} to="/Vessel" className="shadow-sm border-0"
              style={{ maxWidth: "360px", borderRadius: "12px", overflow: "hidden" }}>
              <PixelTransition
                firstContent={
                  <img src="https://stevinshipping.com/wp-content/uploads/2022/08/12-freight-forwarding-and-time-chartering.png" alt="Rug"
                    style={{ width: "100%", height: "100%", objectFit: "cover", aspectRatio: "4/3" }} />
                }
                secondContent={
                  <div style={{ width: "100%", height: "100%", display: "grid", placeItems: "center", backgroundColor: "#111", aspectRatio: "4/3" }}>
                    <p variant="outline-light" className="fw-bold text-center" style={{ fontSize: "clamp(1.25rem, 2vw, 2rem)" }}>Vessels Chartering</p>
                  </div>
                }
                gridSize={12} pixelColor="#ffffff" animationStepDuration={0.4} className="custom-pixel-card"
              />
            </Figure>
          </Col>
        </Row>

        <Row className="g-4 justify-content-center my-4">
          {/* Global Freight Forwarding */}
          <Col xs={12} sm={6} md={4} className="d-flex justify-content-center">
            <Figure as={Link} to="/Global" className="shadow-sm border-0"
              style={{ maxWidth: "360px", borderRadius: "12px", overflow: "hidden" }}>
              <PixelTransition
                firstContent={
                  <img src="https://stevinshipping.com/wp-content/uploads/2022/08/Global-Freight-Forwarding.jpg" alt="Cushions"
                    style={{ width: "100%", height: "100%", objectFit: "cover", aspectRatio: "4/3" }} />
                }
                secondContent={
                  <div style={{ width: "100%", height: "100%", display: "grid", placeItems: "center", backgroundColor: "#111", aspectRatio: "4/3" }}>
                    <p variant="outline-light" className="fw-bold text-center" style={{ fontSize: "clamp(1.25rem, 2vw, 2rem)" }}>Global Freight Forwarding</p>
                  </div>
                }
                gridSize={12} pixelColor="#ffffff" animationStepDuration={0.4} className="custom-pixel-card"
              />
            </Figure>
          </Col>

          {/* Logistics and Warehousing */}
          <Col xs={12} sm={6} md={4} className="d-flex justify-content-center">
            <Figure as={Link} to="/Logistics" className="shadow-sm border-0"
              style={{ maxWidth: "360px", borderRadius: "12px", overflow: "hidden" }}>
              <PixelTransition
                firstContent={
                  <img src="https://stevinshipping.com/wp-content/uploads/2022/08/Logistics-and-Warehousing.jpg" alt="BedBath"
                    style={{ width: "100%", height: "100%", objectFit: "cover", aspectRatio: "4/3" }} />
                }
                secondContent={
                  <div style={{ width: "100%", height: "100%", display: "grid", placeItems: "center", backgroundColor: "#111", aspectRatio: "4/3" }}>
                    <p variant="outline-light" className="fw-bold text-center" style={{ fontSize: "clamp(1.25rem, 2vw, 2rem)" }}>Logistics and Warehousing</p>
                  </div>
                }
                gridSize={12} pixelColor="#ffffff" animationStepDuration={0.4} className="custom-pixel-card"
              />
            </Figure>
          </Col>

          {/* Import*/}
          <Col xs={12} sm={6} md={4} className="d-flex justify-content-center">
            <Figure as={Link} to="/Import" className="shadow-sm border-0"
              style={{ maxWidth: "360px", borderRadius: "12px", overflow: "hidden" }}>
              <PixelTransition
                firstContent={
                  <img src="https://stevinshipping.com/wp-content/uploads/2022/08/steel_2_1623760324208_1653449256030.jpg" alt="KitchenDining"
                    style={{ width: "100%", height: "100%", objectFit: "cover", aspectRatio: "4/3" }} />
                }
                secondContent={
                  <div style={{ width: "100%", height: "100%", display: "grid", placeItems: "center", backgroundColor: "#111", aspectRatio: "4/3" }}>
                    <p variant="outline-light" className="fw-bold text-center" style={{ fontSize: "clamp(1.25rem, 2vw, 2rem)" }}>Import</p>
                  </div>
                }
                gridSize={12} pixelColor="#ffffff" animationStepDuration={0.4} className="custom-pixel-card"
              />
            </Figure>
          </Col>

          {/* Customs ,Vat and
Duty Management */}
          <Col xs={12} sm={6} md={4} className="d-flex justify-content-center">
            <Figure as={Link} to="/Customs" className="shadow-sm border-0"
              style={{ maxWidth: "360px", borderRadius: "12px", overflow: "hidden" }}>
              <PixelTransition
                firstContent={
                  <img src="https://stevinshipping.com/wp-content/uploads/2022/08/Customs-Vat-and-Duty-Management.jpg" alt="Accessories"
                    style={{ width: "100%", height: "100%", objectFit: "cover", aspectRatio: "4/3" }} />
                }
                secondContent={
                  <div style={{ width: "100%", height: "100%", display: "grid", placeItems: "center", backgroundColor: "#111", aspectRatio: "4/3" }}>
                    <p variant="outline-light" className="fw-bold text-center" style={{ fontSize: "clamp(1.25rem, 2vw, 2rem)" }}>Customs ,Vat and Duty Management</p>
                  </div>
                }
                gridSize={12} pixelColor="#ffffff" animationStepDuration={0.4} className="custom-pixel-card"
              />
            </Figure>
          </Col>

          {/* Air Chartering and
Freight Management */}
          <Col xs={12} sm={6} md={4} className="d-flex justify-content-center">
            <Figure as={Link} to="/AirChartering" className="shadow-sm border-0"
              style={{ maxWidth: "360px", borderRadius: "12px", overflow: "hidden" }}>
              <PixelTransition
                firstContent={
                  <img src="https://stevinshipping.com/wp-content/uploads/2022/08/Air-Chartering-and-Freight-Management.jpg" alt="Lights"
                    style={{ width: "100%", height: "100%", objectFit: "cover", aspectRatio: "4/3" }} />
                }
                secondContent={
                  <div style={{ width: "100%", height: "100%", display: "grid", placeItems: "center", backgroundColor: "#111", aspectRatio: "4/3" }}>
                    <p variant="outline-light" className="fw-bold text-center" style={{ fontSize: "clamp(1.25rem, 2vw, 2rem)" }}>Air Chartering and Freight Management</p>
                  </div>
                }
                gridSize={12} pixelColor="#ffffff" animationStepDuration={0.4} className="custom-pixel-card"
              />
            </Figure>
          </Col>
        </Row>
      </Container>

      {/* EARTH  */}
      <article
        className="articleStyle w-100 d-flex flex-column justify-content-center align-items-center"
        style={{ minHeight: "50vh" }}
      >
        <h1 className="headingStyle mb-4">OUR NETWORK</h1>

        <div style={{ width: "400px", height: "400px" }}>
          <Earth />
        </div>
      </article>

      {/* Our Director */}
      <Container fluid className="overflow-hidden bg-dark text-light">
        <Row className="mx-2 my-2 d-flex justify-content-center align-items-center text-center text-md-start">

          {/* Image Column */}
          <Col xs={12} md={4} className="mb-4 mb-md-0">
            <h2 className="fw-bold mb-3">Our Director's Message</h2>
            {/* <Image src={Director} rounded fluid className="director-img" /> */}
          </Col>

          {/* Text Column */}
          <Col xs={12} md={8}>
            <h2 className="fw-bold">DELTRANS GLOBAL FZE LLC</h2>
            <h5 className="mb-3">Director</h5>

            <ScrollReveal
              baseOpacity={10}
              enableBlur={true}
              baseRotation={2}
              blurStrength={10}
              className="director-text mt-2"
            >
              At Deltrans, we pride ourselves on being more than just a freight forwarding company; we are partners in your success. Our mission is to connect businesses across borders, streamline supply chains, and ensure the seamless movement of goods with reliability and precision. Since our inception, we have dedicated ourselves to delivering tailored logistics solutions that cater to the diverse needs of our clients. With a team of skilled professionals, a global network of partners, and cutting-edge technology, we ensure that your cargo reaches its destination safely, efficiently, and on time. In today’s fast-paced and ever-evolving world of logistics, our commitment to innovation and excellence remains steadfast. We believe in fostering strong relationships with our clients, built on trust, transparency, and mutual growth. At Deltrans, every shipment is handled with the utmost care, reflecting our promise of delivering excellence. Thank you for entrusting us with your logistics needs. Together, we look forward to navigating new horizons and driving progress across industries worldwide. Sincerely
            </ScrollReveal>
          </Col>
        </Row>
      </Container>

      {/* GSAP  */}
      {/* <div>
        <Animate />
      </div> */}

      {/* Count Up */}
      <Container fluid className='p-2 img-bg d-flex align-items-center justify-content-center text-center'>
        <Row className='text-light m-4 justify-content-center align-items-center '>
          <Col md={7}>
            <h1 className='justify-text typed-text text-shadow'>DELTRANS</h1>
            <p className='justify-text para text-shadow'>A globally integrated, Vessel Operating Common Carrier (VOCC), is a federally licensed and bonded Ocean Transport Intermediary with over 4 years of global shipping expertise. Extensive carrier confidential contracts and close overseas partnerships enable us to move cargo between any point in the India to any point worldwide. Our strong international network insures that our excellent service extends beyond the IN. By providing a personalized customer experience and developing strong intercompany relationships we complement our customer’s success by offering reliable, worry free transportation.</p>
            <div className="text-start">
              <Button
                as={Link}
                to="/About"
                variant="outline-light"
                size="lg"
                className='text-shadow'
              >
                Know More
              </Button>
            </div>
          </Col>
          <Col md={5} className="text-end">
            <div>
              <CountUp
                from={0}
                to={3000}
                separator=","
                direction="up"
                duration={1}
                className="count-up-text text-shadow typed-text"
              />
              <p className='fs-3 fw-bold text-shadow'>m<sup>2&lt;/sup </sup></p>
              <p className='fs-5 fw-bold text-shadow'>Total warehouse area</p>
            </div>

            <div>
              <CountUp
                from={0}
                to={1200}
                separator=","
                direction="up"
                duration={1}
                className="count-up-text text-shadow typed-text"
              />
              <p className='fs-5 fw-bold text-shadow'>Created Jobs</p>
            </div>
          </Col>
        </Row>
      </Container>

      {/* ScrollVelocity  */}
      <Container className='py-5 bg-dark text-light' fluid>
        <h1 className='text-center gradient-text'>DELTRANS GLOBAL</h1>
        <ScrollVelocity
          texts={["Project Bulk and ODC Cargo Unit | Vessels Chartering | Global Freight Forwarding |", "Logistics and Warehousing | Steel Import |", "Customs ,Vat and Duty Management | Air Chartering and Freight Management |"]}
          velocity={60}
          className="fw-bold fs-2 text-light m-3"
        // parallaxClassName="overflow-hidden text-center"
        // scrollerClassName="d-inline-flex align-items-center"
        />
      </Container>

      {/* Company Logo  */}
      <Container fluid className="gx-0 px-0 overflow-hidden" >
        <h1 className='text-center typed-text text-dark'>
          Companies Who Trust Us
        </h1>
        {/* <MarqueeDemo /> */}
      </Container>


    </>
  );
}

export default DarkVariantExample;